export function formatWalletAmount(value: string, locale: string): string {
  const match = /^(-?)(\d+)(?:\.(\d{1,5}))?$/.exec(value);
  if (!match) return value;

  const integer = new Intl.NumberFormat(locale, { useGrouping: true }).format(
    BigInt(`${match[1]}${match[2]}`),
  );
  const fraction = (match[3] ?? '').replace(/0+$/, '');
  if (!fraction) return integer;

  const formatter = new Intl.NumberFormat(locale, { useGrouping: false });
  const decimal = formatter
    .formatToParts(1.1)
    .find((part) => part.type === 'decimal')?.value;
  const localizedFraction = [...fraction]
    .map((digit) => formatter.format(Number(digit)))
    .join('');

  return `${integer}${decimal ?? '.'}${localizedFraction}`;
}
